import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get, findIndex } from 'lodash'
import { compose } from 'recompose'

import { Modal } from 'containers/misc'
import { Select } from 'components/fields'
import { Title, Span } from 'components/layout'
import { Button, BadgesLevels } from 'components/misc'
import { Table, Data } from 'components/layout/Table'
import { modal, notification } from 'redux/modules/app'
import { apiAjEvents } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { getActiveRole } from 'utils/token'
import { ROLES, PROGRESS_STATES } from 'constants/enums'
import { mapParticipantsForSelect } from 'redux/selectors/participants'
import activeAward from 'helpers/activeAward'

const enhance = compose(
  apiAjEvents({
    detail: true
  }),
  form({
    form: 'addAjEventParticipants',
    disableHook: true
  }),
  connect(
    ({ auth }) => ({
      activeOrganization: auth.organization
    }),
    { modal, notification }
  )
)

class AjEventAddParticipant extends Component {
  static propTypes = {
    ajEvents: PropTypes.object.isRequired,
    disableManagingParticipants: PropTypes.bool,
    searchAjEventParticipants: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    activeOrganization: PropTypes.object,
    setAjEventParticipants: PropTypes.func.isRequired
  }

  state = {
    selectedParticipants: [],
    originalParticipantsCount: 0,
    isLoading: false
  }

  componentWillReceiveProps(nextProps) {
    const thisAjParticipantEvents = get(
      this.props,
      'ajEvents.detail.ajParticipantEvents'
    )
    const nextAjParticipantEvents = get(
      nextProps,
      'ajEvents.detail.ajParticipantEvents'
    )

    if (thisAjParticipantEvents !== nextAjParticipantEvents) {
      this.setState({
        selectedParticipants: nextAjParticipantEvents.map(({ award }) => ({
          award,
          participantId: get(award, 'participant.id')
        })),
        originalParticipantsCount: nextAjParticipantEvents.length
      })
    }
  }

  handleModalOpen = () => {
    const { activeOrganization, ajEvents: { detail } } = this.props

    if (getActiveRole(activeOrganization) === ROLES.LEADER.u) {
      this.setState({ isLoading: true })
      this.props
        .searchAjEventParticipants(
          {},
          {
            awardLevelValue: get(detail, 'awardLevel.value'),
            disableNameFilter: true,
            rejectStates: [
              // PROGRESS_STATES.awardSetup.id,
              PROGRESS_STATES.awardRegAssessment.id,
              PROGRESS_STATES.awardRegApproval.id
            ]
          }
        )
        .then(() => {
          this.setState({ isLoading: false })
          this.props.modal('aj-event-set-participants')
        })
        .catch(() => {
          this.setState({ isLoading: false })
        })
      return
    }

    this.props.modal('aj-event-set-participants')
  }

  handleModalClose = () => this.props.modal(null)

  handleParticipantAdd = (obj = {}) => {
    const { ajEvents: { searchResults, detail } } = this.props
    const { selectedParticipants } = this.state
    const value = get(obj, 'value')
    const ajEventForAwardValue = get(detail, 'awardLevel.value')

    if (
      selectedParticipants.some(item => get(item, 'participantId') === value)
    ) {
      this.props.notification('Participant is already in the list', {
        status: 'success',
        intlKey: 'notifications.participant_is_already_in_list'
      })
      return
    }

    const clickedOnParticipant = searchResults.filter(
      item => item.id === value
    )[0] || {}

    let activeIndex = findIndex(clickedOnParticipant.awards, o => {
      return get(o, 'awardLevel.value') === ajEventForAwardValue
    })

    if (activeIndex < 0) {
      activeIndex = activeAward(clickedOnParticipant) || 0
    }

    const selectParticipant = searchResults
      .filter(item => item.id === value)
      .map(item => ({
        award: item.awards[activeIndex],
        participantId: value,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email
      }))

    this.setState({
      selectedParticipants: selectedParticipants.concat(selectParticipant)
    })
  }

  handleParticipantRemove = id => {
    const { selectedParticipants } = this.state

    this.setState({
      selectedParticipants: selectedParticipants.filter(
        item => item.award.id !== id
      )
    })
  }

  render() {
    const {
      ajEvents: { searchResults, detail },
      handleSubmit,
      setAjEventParticipants,
      submitting,
      activeOrganization,
      disableManagingParticipants
    } = this.props
    const {
      selectedParticipants,
      isLoading,
      originalParticipantsCount
    } = this.state
    const isLeader = getActiveRole(activeOrganization) === ROLES.LEADER.u

    return (
      <div>
        <div className="base-margin--bottom text--right">
          {disableManagingParticipants &&
            <Span
              intlKey="label.aj_is_not_approved_yet"
              style={{
                paddingRight: 16
              }}
              error
            >
              Adventurous Journey is not approved yet
            </Span>}
          <Button
            className="btn"
            intlKey="button.manage_participants"
            isLoading={isLoading}
            onClick={this.handleModalOpen}
            disabled={disableManagingParticipants}
          >
            Manage Participants
          </Button>
        </div>
        <Modal id="aj-event-set-participants" customActions large>
          <form
            onSubmit={handleSubmit(() =>
              setAjEventParticipants(
                get(detail, 'id'),
                get(detail, 'awardLevel.value'),
                selectedParticipants,
                { originalParticipantsCount }
              )
            )}
          >
            <div className="row">
              <div className="col-xs-12">
                {isLeader
                  ? <Select
                      label="Search by email, first or last name"
                      intlKey="label.search_by_email_first_or_last"
                      name="search"
                      options={mapParticipantsForSelect(searchResults)}
                      placeholder="Start typing ..."
                      intlKeyPlaceholder="placeholder.start_typing"
                      onSelectChange={this.handleParticipantAdd}
                      searchable
                    />
                  : <Select
                      label="Search by email, first or last name"
                      intlKey="label.search_by_email_first_or_last"
                      name="search"
                      promise={fields =>
                        this.props.searchAjEventParticipants(fields, {
                          awardLevelValue: get(detail, 'awardLevel.value')
                        })}
                      placeholder="Start typing ..."
                      intlKeyPlaceholder="placeholder.start_typing"
                      updater={searchResults}
                      autocomplete
                      onSelectChange={this.handleParticipantAdd}
                    />}
              </div>
            </div>

            <div>
              {selectedParticipants.length > 0 &&
                <Table>
                  <Data>
                    {selectedParticipants.map(({
                      award,
                      firstName,
                      lastName,
                      email
                    }, index) => (
                      <tr key={get(award, 'id') || `noId-${index}`}>
                        <td>
                          {get(award, 'participant.id') || get(award, 'id')}
                        </td>
                        <td>
                          {get(award, 'participant.firstName') || firstName}
                        </td>
                        <td>
                          {get(award, 'participant.lastName') || lastName}
                        </td>
                        <td>{get(award, 'participant.email') || email}</td>
                        <td>
                          <BadgesLevels
                            levels={[{ awardLevel: get(award, 'awardLevel') }]}
                            single
                          />
                        </td>
                        <td className="text--center">
                          <Button
                            small
                            intlKey="button.remove"
                            onClick={() =>
                              this.handleParticipantRemove(get(award, 'id'))}
                            type="button"
                          >
                            Remove
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </Data>
                </Table>}
              {selectedParticipants.length === 0 &&
                <Title
                  h3
                  intlKey="label.no_selected_participants"
                  className="text--center base-margin"
                >
                  No selected participants
                </Title>}
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    type="button"
                    onClick={this.handleModalClose}
                    secondary
                    intlKey="button.close"
                  >
                    Close
                  </Button>
                </div>
                <div className="col-xs-6 text--right">
                  <Button intlKey="button.save_changes" isLoading={submitting}>
                    Save changes
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    )
  }
}
export default enhance(AjEventAddParticipant)
